import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=06661696&scoped=true&"
import script from "./audit.vue?vue&type=script&lang=js&"
export * from "./audit.vue?vue&type=script&lang=js&"
import style0 from "./audit.vue?vue&type=style&index=0&id=06661696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06661696",
  null
  
)

export default component.exports